import { render } from "./ViewBasicInfo.vue?vue&type=template&id=075c8fca&scoped=true"
import script from "./ViewBasicInfo.vue?vue&type=script&lang=js"
export * from "./ViewBasicInfo.vue?vue&type=script&lang=js"

import "./ViewBasicInfo.vue?vue&type=style&index=0&id=075c8fca&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-075c8fca"

export default script